import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import type { Comic } from '@/mocks/comics';

type ComicSectionProps = {
  title: string;
  subtitle: string;
  moreLink: string;
  comics: Comic[];
  tone?: 'primary' | 'accent' | 'secondary';
};

const toneMap: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function ComicSection({
  title,
  subtitle,
  moreLink,
  comics,
  tone = 'primary',
}: ComicSectionProps) {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-8">
      <div className="mb-6 flex items-end justify-between">
        <div className="flex items-center gap-3">
          <span className={`h-6 w-1.5 rounded-full ${toneMap[tone]}`} />
          <div>
            <h2 className="font-heading text-2xl text-foreground-950">{title}</h2>
            <p className="mt-0.5 text-sm text-foreground-500">{subtitle}</p>
          </div>
        </div>
        <Link
          to={moreLink}
          className="hidden items-center gap-1 whitespace-nowrap text-sm text-secondary-600 transition hover:text-secondary-700 sm:flex"
        >
          查看更多
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
        {comics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}